import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { PrizeType, ScorecardCustomerPrizeOptionItemModel } from '@fgb/core';

@Component({
  selector: 'fgbcl-scorecard-prize-selection',
  templateUrl: './scorecard-prize-selection.component.html',
  styleUrls: ['./scorecard-prize-selection.component.scss'],
})
export class ScorecardPrizeSelectionComponent implements OnInit {
  @Input() prizes: ScorecardCustomerPrizeOptionItemModel[];
  @Input() showPrizeIcon: boolean = false;
  @Output() onPrizeConfirmed: EventEmitter<ScorecardCustomerPrizeOptionItemModel> = new EventEmitter();
  prizeSelected: ScorecardCustomerPrizeOptionItemModel;
  constructor() {}

  ngOnInit(): void {}

  prizeIcon(prizeType: PrizeType) {
    switch (prizeType) {
      case PrizeType.Reward:
        return 'redeem';
      case PrizeType.GivePoints:
        return 'emoji_events';
      case PrizeType.GiveEcash:
        return 'paid';
      case PrizeType.SkuItem:
        return 'shopping_bag';
      case PrizeType.LottoEntry:
        return 'confirmation_number';
      default:
        return 'redeem';
    }
  }

  prizeSelectedCondition(prize: ScorecardCustomerPrizeOptionItemModel) {
    return !prize.SoldOut && prize.PrizeId === this.prizeSelected?.PrizeId;
  }

  onPrizeSelected(prize: ScorecardCustomerPrizeOptionItemModel) {
    if (prize.SoldOut) return;
    this.prizeSelected = prize;
  }

  onPrizeConfirm() {
    this.onPrizeConfirmed.emit(this.prizeSelected);
  }
}
